import { ReactiveItem } from "./ReactiveItem";

export class ReactiveAccordionItem
  extends ReactiveItem<IAccordionItem>
  implements IAccordionItem
{
  // `declare` prevents TypeScript from emitting field initializers that would run
  // after super() and conflict with MobX observable properties set by the base class.
  declare id: number;
  declare terrace_id: number;
  declare children: Array<ReactiveAccordionItem>;
  declare title: string;
  declare description: string;
  declare has_content: boolean;
  declare modal_enabled: boolean;
  declare content: string;
  declare content_html: string;
  declare path: string;
  declare expanded: boolean | undefined;

  constructor(item: IAccordionItem) {
    super(item);
  }
}
